import React from 'react';

export const AugmentationDots = () => (
    <div className="augmentation-container dot-container">
        <div className="note-type half-note"></div><div className="dot"></div>
    </div>
)